import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function Button({
  children,
  className = '',
  href,
  onClick
}: ButtonProps) {
  const content = <>
      <span className="block" data-id="element-30">{children}</span>
      <span className="block text-xs font-normal opacity-80 mt-1" data-id="element-31">
        + Impuestos según tu país
      </span>
    </>;
  if (href) {
    return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`inline-block bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold py-4 px-8 rounded shadow-[0_0_15px_rgba(201,168,76,0.3)] transition-colors duration-300 text-center ${className}`} onClick={onClick} data-id="element-32">
        {content}
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`bg-gold-500 hover:bg-gold-400 text-dark-900 font-bold py-4 px-8 rounded shadow-[0_0_15px_rgba(201,168,76,0.3)] transition-colors duration-300 ${className}`} onClick={onClick} data-id="element-33">
      {content}
    </motion.button>;
}